// extracted by mini-css-extract-plugin
export default {"price":"bna-z","onSale":"cna-z","msrpLabelPrice":"dna-z","msrpLabel":"ena-z","originalPrice":"fna-z"};